import { Navigate } from 'react-router-dom';
import { RouteProps } from '../types/Props';

const PrivateRoute = ({ element, isLoggedIn }: RouteProps) => {
  return isLoggedIn ? element : <Navigate to="/install" />;
};

const PrivateRoutePWA = ({ isLoggedIn, element }: RouteProps) => {
  return isLoggedIn ? element : <Navigate to="/login" />;
};

const PublicRoute = ({ isLoggedIn, element }: RouteProps) => {
  return isLoggedIn ? <Navigate to="/" /> : element;
};

export { PrivateRoute, PrivateRoutePWA, PublicRoute };